<div class="evidence-container" *ngIf="activeVehicle">

  <div class="validation-modal-header">
    <div class="header-info">
      <h3>Evidencias de Unidad</h3>
      <h2>Vehículo: {{ activeVehicle.unitCode }} <span class="plate-text">({{ activeVehicle.plate }})</span></h2>
    </div>
    <button type="button" class="btn-close-custom" (click)="onCancel()">
      <i class="material-icons">close</i>
    </button>
  </div>
  <p class="my-2" style="color: var(--gl-text-secondary);">

  </p>


  <!-- Scrollable Body Content -->
  <div class="evidence-body">

    <!-- Info tip -->
    <div class="info-tip">
      <i class="material-icons text-info-icon">info</i>
      <span>Suba imágenes como evidencia de validación. Puede gestionar las evidencias guardadas eliminándolas o agregando nuevas.</span>
    </div>

    <!-- Upload/Drag Area -->
    <div class="upload-area" [class.dragging]="dragging" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)" (click)="fileInput.click()">
      <input type="file" multiple accept="image/*" #fileInput hidden (change)="onFileSelected($event)" />
      <div class="upload-content">
        <i class="material-icons upload-icon">cloud_upload</i>
        <p>Seleccionar imágenes</p>
        <small>Arrastre archivos aquí o haga clic para buscar</small>
      </div>
    </div>

    <!-- Existing Evidences Section -->
    <div class="section-container" *ngIf="existingEvidences.length > 0">
      <div class="section-title">
        <i class="material-icons title-icon">verified</i>
        <h3>Evidencias Guardadas ({{ existingEvidences.length }})</h3>
      </div>

      <div class="existing-grid">
        <div class="existing-card" *ngFor="let url of existingEvidences">
          <div class="card-image-wrapper">
            <img [src]="url" alt="evidence image" class="existing-img" />

            <div class="image-overlay" *ngIf="!deletingUrls.has(url)">
              <div class="overlay-actions">
                <button type="button" class="btn-overlay-action" (click)="viewImage(url); $event.stopPropagation()" title="Ver imagen">
                  <i class="material-icons">visibility</i>
                </button>
                <button type="button" class="btn-overlay-action btn-delete" (click)="deleteExistingEvidence(url); $event.stopPropagation()" title="Eliminar">
                  <i class="material-icons">delete</i>
                </button>
              </div>
            </div>

            <div class="deleting-overlay" *ngIf="deletingUrls.has(url)">
              <span class="spinner"></span>
            </div>
          </div>
          <div class="card-footer-info">
            <span class="status-badge">Guardado</span>
          </div>
        </div>
      </div>
    </div>

    <!-- New Evidences Queue Section -->
    <div class="section-container" *ngIf="newEvidenceFiles.length > 0">
      <div class="section-title">
        <i class="material-icons title-icon font-blue">pending_actions</i>
        <h3>Nuevas Evidencias por Subir ({{ newEvidenceFiles.length }})</h3>
        <button class="clear-btn-custom" type="button" (click)="clearAll()">
          Limpiar Cola
        </button>
      </div>

      <div class="new-evidence-list">
        <div class="new-evidence-item" *ngFor="let evidence of newEvidenceFiles; let i = index">
          <div class="preview-info-section">
            <img [src]="evidence.preview" alt="preview" class="new-preview" />
            <div class="file-details">
              <span class="file-name">{{ evidence.file.name }}</span>
              <span class="file-size">{{ evidence.sizeLabel }}</span>
            </div>
          </div>

          <div class="actions-section">
            <button class="delete-btn-custom" type="button" (click)="removeNewEvidence(i)" [disabled]="uploading">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Footer Actions -->
  <div class="evidence-footer">
    <button class="btn btn-standar btn-cancel" type="button" (click)="onCancel()" [disabled]="uploading">
      Cancelar
    </button>
    <button class="btn btn-standar btn-standar-success" type="button" (click)="uploadNewEvidences()" [disabled]="newEvidenceFiles.length === 0 || uploading">
      <ng-container *ngIf="!uploading">
        <i class="material-icons">cloud_done</i>
        <span>Subir Evidencias ({{ newEvidenceFiles.length }})</span>
      </ng-container>
      <ng-container *ngIf="uploading">
        <span class="spinner"></span>
        <span>Subiendo...</span>
      </ng-container>
    </button>
  </div>

</div>
